<template>
  <div class="moreInfo-module">
    <div style="text-align:center">
      <div class="moreInfo-module-tab" v-if="dataSource && dataSource.length && dataSource[0] && dataSource[0].businesses && dataSource[0].businesses.length">
        <div :class="['moreInfo-module-tab-item', curIndex === childIndex ? 'active' : '']" v-for="(child, childIndex) in dataSource" :key="child.id" @click="changeChildIndex(childIndex)">
          <template v-if="child.businesses && child.businesses.length > 1">
            <Dropdown>
              {{child.name}}
              <Icon type="ios-arrow-down" />
              <DropdownMenu slot="list">
                <DropdownItem v-for="(bus, index) in child.businesses" :key="bus.id" :selected="child.curIndex === index" @click.native="changeBusIndex(childIndex, index)">
                  {{bus.name}}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </template>
          <template v-if="child.businesses && child.businesses.length === 1">{{child.businesses[0].name}}</template>
        </div>
      </div>
    </div>
    <div v-for="(child, childIndex) in dataSource" :key="child.id">
      <more-info-wrap :ref="'bus' + childIndex" v-if="child.businesses[child.curIndex] && child.businesses[child.curIndex].bind_code"  v-show="childIndex === curIndex" :bus="child.businesses[child.curIndex]" :info="info" />
    </div>
  </div>
</template>
<script>
import moreInfoWrap from "./moreInfoWrap.vue"
export default {
  components: {
    moreInfoWrap
  },
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      curIndex: 0
    }
  },
  methods: {
    changeChildIndex(i) {
      this.curIndex = i;
      this.getList();
      // this.getTrend();
    },
    changeBusIndex(p, c) {
      this.curIndex = p;
      this.getList();
      // this.getTrend();
      this.$emit('changeIndex', {
        p,
        c
      });
    },
    getTrend() {
      if (this.$refs['bus' + this.curIndex] && this.$refs['bus' + this.curIndex].length) {
        this.$refs['bus' + this.curIndex][0].getTrend();
      }
    },
    getList() {
      if (this.$refs['bus' + this.curIndex] && this.$refs['bus' + this.curIndex].length) {
        this.$refs['bus' + this.curIndex][0].getList();
      }
    }
  }
}
</script>
<style lang="less">
.moreInfo-module{
  &-tab{
    margin: 0 auto 20px;
    display: inline-block;
    padding: 3px;
    border-radius: 20px;
    border: solid 1px #e8eaec;
    &-item{
      display: inline-block;
      line-height: 34px;
      padding: 0 15px;
      border-radius: 20px;
      color: #657180;
      cursor: pointer;
      &:hover{
        color: #2d8cf0;
      }
      &.active{
        color: #fff;
        background-color: #2d8cf0;
      }
    }
  }
}
</style>